// menu-trigger on click add menu-layer active class
let menuTrigger = document.querySelector('.menu-trigger');
if (menuTrigger) {
    menuTrigger.addEventListener('click', function () {
        document.querySelector('.menu-layer').classList.add('active');
    });
    document.querySelector('.menu-trigger-close').addEventListener('click', function() {
        document.querySelector('.menu-layer').classList.remove('active');
    });
}

let menuLayerImgLinks = document.querySelectorAll('.menu-layer a[data-img]');
if (menuLayerImgLinks) {
    menuLayerImgLinks.forEach((link) => {
        link.addEventListener('mouseover', function() {
            let imgSrc = this.getAttribute('data-img');
            document.querySelector('.menu-layer-img img').setAttribute('src', imgSrc);
        });
    });
}



// add scroll class to site-header on scroll
/*window.addEventListener('scroll', function() {
    const header = document.querySelector('.site-header');
    if (window.scrollY > 200) {
        header.classList.add('scroll');
    } else {
        header.classList.remove('scroll');
    }

    let scrollDirection = window.scrollY > this.lastScroll ? 'down' : 'up';
    if (scrollDirection === 'down' && window.scrollY > 200) {
        header.style.transform = 'translateY(-100%)';
    } else {
        header.style.transform = 'translateY(0)';
    }
    this.lastScroll = window.scrollY;

});*/


function setResponsiveVideo() {
    let videos = document.querySelectorAll('video');
    if (videos) {
        videos.forEach((video) => {
            if (window.innerWidth < 800) {
                video.setAttribute('src', video.dataset.src_mobile);
            } else {
                video.setAttribute('src', video.dataset.src);
            }
        })
    }
}
setResponsiveVideo();

// close other details when one is opened
let detailsElements = document.querySelectorAll('details');
if (detailsElements) {
    detailsElements.forEach((details) => {
        details.addEventListener('toggle', function() {
            if (this.open) {
                detailsElements.forEach((otherDetails) => {
                    if (otherDetails !== this) {
                        otherDetails.removeAttribute('open');
                    }
                });
            }
        });
    });
}

/* steam effect js */

let steamBtn = document.getElementById('steam-btn');
if (steamBtn) {
    steamBtn.addEventListener('click', function () {
        const container = document.getElementById('steam-container');
        const bubbleCount = 8;
        for (let i = 0; i < bubbleCount; i++) {
            const steam = document.createElement('div');
            steam.className = 'steam';
            steam.style.left = (30 + Math.random() * 40) + '%';
            steam.style.width = (120 + Math.random() * 120) + 'px';
            steam.style.height = (180 + Math.random() * 120) + 'px';
            steam.style.animationDelay = (Math.random() * 0.3) + 's';
            container.appendChild(steam);
            setTimeout(() => {
                steam.remove();
            }, 2200); // Slightly longer to match possible delay
        }
    });
}
